export const loadScript = (name,src,callback) => {
    const existingScript = document.getElementById(name);

    if (!existingScript) {
        const script = document.createElement('script');
        script.src = src;
        script.id = name;
        document.body.appendChild(script);

        script.onload = () => {
            if (callback) callback();
            // console.log(name + ' loaded')
        };
    }

    if (existingScript && callback) callback();
};


// WEBPACK FOOTER //
// ./src/utilities/loadScript.js